// Fix of query and hash on uri when Router in hash mode
location.replace(location.pathname + location.hash + location.search)

/* eslint-disable import/first */
import Vue from 'vue'
import Cookie from 'js-cookie'
import App from './App'
import router from './router'
import MarketingSourcesPlugin from '@/plugins/marketing_source'
import VueGtm from '@/plugins/vue-gtm'
import 'vue-search-select/dist/VueSearchSelect.css'

const globalConfig = (Vue.prototype.$globalConfig = require('../../../app.config'))

Vue.use(MarketingSourcesPlugin)

Vue.use(VueGtm, {
    id: globalConfig.analytics.google_tag_manager.id,
    queryParams: globalConfig.analytics.google_tag_manager.queryParams,
    enabled: globalConfig.analytics.google_tag_manager.enabled,
    debug: process.env.NODE_ENV === 'development',
    loadScript: true,
    vueRouter: router,
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    methods: {
        cleanMarketingData() {
            const cookieDomain = '.' + location.hostname
            Cookie.remove('http_referrer', { domain: cookieDomain })
            Cookie.remove('utm', { domain: cookieDomain })
            Cookie.remove('kayakclickid', { domain: cookieDomain })

            // Deprecated
            Cookie.remove('utm_source', { domain: cookieDomain })
        },
        getMarketingData() {
            let utmFields = {
                // Deprecated
                source: Cookie.get('utm_source'),
            }

            try {
                utmFields = JSON.parse(Cookie.get('utm'))
            } catch (e) {}

            return {
                _gacid: this.$gtm.clientId,
                _httpreferrer: Cookie.get('http_referrer'),
                _utmsource: utmFields.source,
                _utmmedium: utmFields.medium,
                _utmcampaign: utmFields.campaign,
                _utmterm: utmFields.term,
                _utmcontent: utmFields.content,
                _kcid: Cookie.get('kayakclickid'),
            }
        },
    },
    template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/pages/index/main.js